/**
 * PersonTypeahead
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Form
import { RenderDropdown } from '../../forms';

// Selectors
import { selectOptions } from './selectors';

interface Props {
    options: {
        id: number,
        name: string
    }[];
    personIdIsEnabled?: boolean;
    label?: string;
    placeholder?: string;
    name: string;
    validate?: Function | Function[];
    normalize?: Function;
    multiple?: boolean;
    disabled?: boolean;
    type?: string;
}

export class PersonTypeahead extends React.PureComponent<Props> {
    render() {
        const {
            options,
            label,
            placeholder,
            name,
            validate,
            normalize,
            multiple,
            disabled,
            type
        } = this.props;
        return (
            <Field
                component={RenderDropdown}
                label={label}
                name={name}
                options={options}
                placeholder={placeholder}
                clearable={!disabled}
                fluid
                search
                selection
                validate={validate}
                normalize={normalize}
                multiple={multiple}
                disabled={disabled}
                closeOnChange
                upward={false}
                lazyLoad
                type={type}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    options: selectOptions
});

export default connect(mapStateToProps)(PersonTypeahead);
